module.exports = __webpack_public_path__ + "img/logo_centered.566b5f5d.svg";